import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useMount } from 'react-use';
import { routingService } from 'services/routing';
import { useCompanyIdBasedOnUrl } from 'shared/hooks';
import { getPath } from 'urlBuilder';

import { kycStatusToPageMap } from '../constants';
import { useLazyKycData } from './useLazyKycData';

export const useKycInitialRedirection = () => {
    const { companyId } = useCompanyIdBasedOnUrl();
    const { status } = useParams<{ status: string }>();
    const { getKyc, data, isFetching } = useLazyKycData();

    useMount(() => {
        if (!status) {
            void getKyc({ params: { path: { organizationId: companyId } } });
        }
    });

    useEffect(() => {
        if (!data?.status) {
            return;
        }

        routingService.push(getPath(kycStatusToPageMap[data.status], companyId));
    }, [companyId, data?.status]);

    return { isFetching };
};
